import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from "@mui/material"
import { GridExpandMoreIcon } from "@mui/x-data-grid"
import { ReactNode } from "react"
import { useLocalStorage } from "usehooks-ts"

type NodeDrawerAccordionProps = {
  children: ReactNode | ReactNode[]
  label: string
  id: string
  expand?: boolean
}

const NodeDrawerAccordion = ({ expand = true, ...props }: NodeDrawerAccordionProps) => {
  const [isExpanded, setIsExpanded] = useLocalStorage(`NodeDrawerAccordion-${props.id}`, expand)

  return (
    <Accordion
      square
      disableGutters
      variant="section"
      expanded={isExpanded}
      onChange={(_event, isExpanded) => setIsExpanded(isExpanded)}
    >
      <AccordionSummary expandIcon={<GridExpandMoreIcon />}>
        <Typography sx={{ fontWeight: 700 }}>{props.label}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container gap={1} direction="column">
          {isExpanded && props.children}
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}

export default NodeDrawerAccordion
